export const mainPath = "https://optima.beupsoft.pl/api/v1";